var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusiness(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.607 21.3921H50.5581V19.3323C50.5581 17.6324 49.1657 16.2427 47.4684 16.2427H33.8684V14.4438C33.8684 11.8841 31.7866 9.81061 29.2353 9.81061H21.3257C20.0898 9.81061 18.9281 10.2939 18.0492 11.1728C17.1703 12.0517 16.6897 13.2051 16.6897 14.4438V16.2453H3.08966C1.38969 16.2427 0 17.6322 0 19.3323V46.9253L10.3869 25.8825C11.6475 23.32 14.7563 21.3921 17.607 21.3921ZM19.7795 14.4438C19.7795 14.0346 19.947 13.6473 20.2354 13.3562C20.5238 13.0595 20.9138 12.8976 21.323 12.8976H29.2326C30.0868 12.8976 30.7761 13.5897 30.7761 14.4438V16.2453H19.7796V14.4438H19.7795Z",
    fill: "#17B9DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9887 24.4763H17.6071C15.9098 24.4763 13.9023 25.7232 13.1579 27.2446L1.22224 51.4238C0.469781 52.9426 1.24694 54.1894 2.94424 54.1894H47.3258C49.0231 54.1894 51.0335 52.9452 51.7805 51.4238L63.7135 27.2446C64.4632 25.7232 63.6915 24.4763 61.9887 24.4763Z",
    fill: "#17B9DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness);
export default __webpack_public_path__ + "static/media/business.8014552c0ec84a04b3501c58e36d3675.svg";
export { ForwardRef as ReactComponent };